import React, { useState } from "react";
import { useGetUsersQuery, useDeleteUserMutation } from "../../redux/api/userManagementApi";
import { AgGridReact } from "ag-grid-react";
import { Button, Modal, notification } from "antd";
import AddUserModal from "./AddUserModal";

const AdminUserManagemenTab = () => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [deleteUser, { isLoading: isDeleting }] = useDeleteUserMutation();

  const showDeleteConfirm = (userData) => {
    setSelectedUser(userData);
    setIsModalVisible(true);
  };

  const handleDelete = () => {
    if (selectedUser) {
        setIsModalVisible(false);
      deleteUser(selectedUser.id).unwrap()
        .then(() => {
          notification.success({
            message: "User Deleted Successfully",
            description: `User ${selectedUser.user_email} has been deleted.`,
            placement: "bottomRight"
          });
          setSelectedUser(null);
        })
        .catch((error) => {
          notification.error({
            message: "Error Deleting User",
            description: error.message || "An error occurred while deleting the user.",
            placement: "bottomRight"
          });
          setIsModalVisible(false);
          setSelectedUser(null);
        });
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedUser(null);
  };

  const DeleteButtonRenderer = (props) => (
    <Button  
      onClick={() => showDeleteConfirm(props.data)}
    >
      Delete
    </Button>
  );

  const columnDefs = [
    { 
      field: "user_email", 
      headerName: "User Email", 
      width: 400,
      filter: 'agTextColumnFilter',
      floatingFilter: true
    },
    { 
      field: "claim_value", 
      headerName: "Claim Value",
      filter: 'agTextColumnFilter',
      floatingFilter: true
    },
    {
      headerName: "Delete",
      cellRenderer: DeleteButtonRenderer,
      width: 100,
      filter: false
    }
  ];

  const defaultColDef = {
    sortable: true,
    filter: true,
    filterParams: {
      buttons: ['reset', 'apply'],
      closeOnApply: true
    }
  };

  const { data: users, isLoading, error, isFetching} = useGetUsersQuery();

  const appName = process.env.REACT_APP_APP_NAME;
  console.log(users);
  return (
    <div>
      <div style={{
        height: "50vh",
        width: "60vw",
      }}>
        <AgGridReact
          rowData={users?.filter(user => user.app_name === appName)}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          loading={isLoading || isFetching || isDeleting}
          error={error}
        />
      </div>
      <Modal
        title="Confirm Delete Record"
        open={isModalVisible}
        onOk={handleDelete}
        onCancel={handleCancel}
        okText="Yes, Delete"
        cancelText="No, Cancel"
        okButtonProps={{ danger: true }}
      >
        {selectedUser && (
          <div>
            <p>Are you sure you want to delete this record?</p>
            <p><strong>User Email:</strong> {selectedUser.user_email}</p>
            <p><strong>Claim Value:</strong> {selectedUser.claim_value}</p>
          </div>
        )}
      </Modal>
      <AddUserModal />
    </div>
  );
};

export default AdminUserManagemenTab;
